<template>
    <div>
        <el-button :loading="handleSaveLoading" style="float: right;margin-right: 5px;" icon='el-icon-document' size='mini' type="primary" @click="dataFormSubmit()">保存</el-button>
        <span style="color: red;font-size: 12px;float:right;line-height: 30px;margin-right: 20px;">* 请先保存企业概况，其它信息后续进行操作。</span>

        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" style="margin-top:10px" label-position="right"
                 label-width="140px">
            <h3>基础信息</h3>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="企业名称11" prop="enterpriseName">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.enterpriseName}}</div>
                            <el-input size="small" v-model="dataForm.enterpriseName"/>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="企业简称" prop="venderAbbreviation">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.venderAbbreviation}}</div>
                            <el-input size="small" v-model="dataForm.venderAbbreviation"/>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="企业性质" prop="enterpriseNature">
                        <el-select size="small" v-model="dataForm.enterpriseNature" style="width: 100%;">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="注册地址" prop="address">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.address}}</div>
                            <el-input size="small" v-model="dataForm.address"/>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="供应商代码" prop="venderCode">
                        <el-input size="small" v-model="dataForm.venderCode" disabled/>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="社会信用代码" prop="creditCode">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.creditCode}}</div>
                            <el-input size="small" v-model="dataForm.creditCode"></el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="邮政编码" prop="postCode">
                        <el-input size="small" v-model="dataForm.postCode"/>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="法人代表" prop="legalPerson">
                        <el-input size="small" v-model="dataForm.legalPerson"/>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="供应商关系" prop="venderType">
                        <el-select size="small" v-model="dataForm.venderType" style="width: 100%;">
                            <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="传真" prop="fax">
                        <el-input size="small" v-model="dataForm.fax"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="电话" prop="tel">
                        <el-input size="small" v-model="dataForm.tel"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="网址" prop="website">
                        <el-input size="small" v-model="dataForm.website"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="8">
                    <el-form-item label="省" prop="province">
                        <el-select size="small" v-model="dataForm.province" filterable clearable placeholder="请选择省份" style="width: 100%;">
                            <el-option v-for="item in provinceOptions" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                          </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="市" prop="city">
                            <el-input size="small" v-model="dataForm.city"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="企业股权情况" prop="venturePartner">
                        <el-input size="small" v-model="dataForm.venturePartner"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="供应商经验" prop="venderExpierence">
                        <el-input size="small" v-model="dataForm.venderExpierence"></el-input>
                    </el-form-item>
                </el-col>
              <el-col :span="8">
                <el-form-item label="营业执照到期日期" prop="blEndDate">
                  <el-date-picker  v-model="dataForm.blEndDate" :disabled="dataForm.blLongTerm === 1"  type="date" value-format="yyyy-MM-dd" placeholder="请选择营业执照到期日期">
                  </el-date-picker>
                  <el-checkbox v-model="blLongTermChecked" style="margin-left: 8px;" @change="onBlLongTermChange">长期</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="16949/9000体系证书到期日期" prop="scEndDate">
                  <el-date-picker  v-model="dataForm.scEndDate"  type="date" value-format="yyyy-MM-dd" placeholder="请选择16949/9000体系证书到期日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <h3>电子银行承兑汇票业务信息</h3>
            <el-row :gutter="8">
                <el-col :span="10">
                    <el-form-item label="银行名称" prop="bankName">
                        <el-input disabled="true" size="small" v-model="dataForm.bankName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="开户行行号" prop="swiftCode">
                        <el-input disabled="true" size="small" v-model="dataForm.swiftCode"/>
                    </el-form-item>
                </el-col>
                <el-col :span="1">
                    <el-button size="small" @click="selectBank()">选择</el-button>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="开户行地址" prop="bankAddress">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.bankAddress}}</div>
                            <el-input size="small" v-model="dataForm.bankAddress"/>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="8">
                    <el-form-item label="账户持有人" prop="accountName">
                        <el-tooltip placement="top" effect="light">
                            <div slot="content">{{dataForm.accountName}}</div>
                            <el-input size="small" v-model="dataForm.accountName"/>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="开户账号" prop="accountNum">
                        <el-input size="small" v-model="dataForm.accountNum"/>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="8">
                    <el-form-item label="税务登记号" prop="taxNum">
                        <el-input size="small" v-model="dataForm.taxNum"/>
                    </el-form-item>
                </el-col> -->
            </el-row>
            <h3>供应商情况简介</h3>
            <el-row :gutter="8">
                <el-col>
                    <el-form-item label="情况简介" prop="venderIntroduce">
                        <el-input type="textarea" maxlength="500" :rows="3"
                                  v-model="dataForm.venderIntroduce"/>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <!-- 弹窗, 查询银行表-->
        <bank-list ref="addOrUpdateBank"></bank-list>
    </div>
</template>

<script>
    import {saveSupplierBasicInfo, getSupplierBasicInfoByInviteId} from '@/controller/portal'
    import {getBankList,getBankCount,getProvinceList} from '@/controller/systemData'
    import {DIALOG_CLOSED_TYPE} from "@/utils/const";
    import {mapping} from "@/utils";
    import BankList from "./bank-list";
    export default {
        components: {
            BankList
        },
        data() {
            return {
                bankList: [],
                handleSaveLoading:false,
                pageIndex: 1,
                pageSize: 10,
                dataList: [],
                dataRule: {
                    enterpriseName: [{required: true, message: '不能为空', trigger: 'blur'}],
                    venderAbbreviation: [{required: true, message: '不能为空', trigger: 'blur'}],
                    enterpriseNature: [{required: true, message: '不能为空', trigger: 'blur'}],
                    address: [{required: true, message: '不能为空', trigger: 'blur'}],
                    creditCode: [{required: true, message: '不能为空', trigger: 'blur'}],
                    postCode: [{required: true, message: '不能为空', trigger: 'blur'}],
                    legalPerson: [{required: true, message: '不能为空', trigger: 'blur'}],
                    accountName: [{required: true, message: '不能为空', trigger: 'blur'}],
                    accountNum: [{required: true, message: '不能为空', trigger: 'blur'}],
                    bankAddress: [{required: true, message: '不能为空', trigger: 'blur'}],
                    swiftCode: [{required: true, message: '不能为空', trigger: 'blur'}],
                    venderIntroduce: [{required: true, message: '不能为空', trigger: 'blur'}],
                    province: [{required: true, message: '不能为空', trigger: 'blur'}],
                    city: [{required: true, message: '不能为空', trigger: 'blur'}],
                    blEndDate: [{required: true, message: '不能为空', trigger: 'blur'}],
                    scEndDate: [{required: true, message: '不能为空', trigger: 'blur'}],

                },
                options: [
                    {label: '私有控股', value: '0'},
                    {label: '国有（集体）控股', value: '1'},
                    {label: '中外合资企业', value: '2'},
                    {label: '外商独资企业', value: '3'}
                ],
                options2: [
                    {label: '公司所属供应商', value: '0'},
                    {label: '股东供应商', value: '1'},
                    {label: '一般供应商', value: '2'}
                ],
                dataForm: {
                    venderAbbreviation:'',
                    enterpriseName: '',
                    venderCode: '',
                    venderType: '',
                    basicInfoId: '',
                    enterpriseNature: '',
                    venturePartner: '',
                    address: '',
                    creditCode: '',
                    postCode: '',
                    legalPerson: '',
                    taxNum: '',
                    bankName: '',
                    fax: '',
                    accountName: '',
                    accountNum: '',
                    bankAddress: '',
                    paynum: '',
                    venderIntroduce: '',
                    swiftCode: '',
                    venderSource: '',
                    workflowId: '',
                    province:'',
                    city:'',
                    website:'',
                    tel:'',
                    venderExpierence:'',
                    blEndDate:'',
                    scEndDate:'',
                    blLongTerm: null,
                },
                venderInviteFid: '',
                user: '',

                // 省
                provinceOptions:[],
                // 校验开户行行号
                checkBankCode: undefined,
                // 营执照长期标识checkbox
                blLongTermChecked: false,
                
            }
        },
        props: {
            superId: Number
        },
        mounted() {
            this.getList()
        },
        watch: {
            venderInviteFid() {
                this.getDataList()
            }
        },
        methods: {
            // 营执照长期标识勾选变更
            onBlLongTermChange(val) {
                if (val) {
                    this.dataForm.blLongTerm = 1
                    this.dataForm.blEndDate = ''
                    // 勾选长期时到期日期非必填
                    this.dataRule.blEndDate = []
                } else {
                    this.dataForm.blLongTerm = 0
                    this.dataRule.blEndDate = [{required: true, message: '不能为空', trigger: 'blur'}]
                }
            },
            // init(){
            //     console.log(id, '============init==============')
            //     this.$nextTick(()=>{
            //         this.getBankList()
            //     })
            // },

            getList() {


                // listInvitedForSupplier().then(data => {
                //     // this.dataForm.workflowId = data.body.records[0].workflowId
                //     // this.dataForm.enterpriseName = data.body.records[0].venderName
                //     // this.dataForm.venderSource = data.body.records[0].venderSource
                //     // this.dataForm.venderCode = data.body.records[0].venderCode
                //     // this.dataForm.address = data.body.records[0].venderAdd
                //     // this.venderInviteFid = data.body.records[0].id
                //     // this.createdBy = data.body.records[0].createBy//TODO 采购员
                //     // this.setId()
                // })
            },
            // 根据邀请id从基本信息表查询该公司信息
            getDataList(superId) {
                // 银行列表
                //this.getBankList()
                // 省份列表
                this.getProvinceList()
                var v;
                if(superId){
                    v = superId
                }else{
                    v = this.superId
                }
                getSupplierBasicInfoByInviteId({
                    'inviteId': v
                }).then(data => {
                    if (data && data.code === '00') {
                        if (data.body) {
                            this.dataForm.basicInfoId = data.body.id
                            this.dataForm.enterpriseName = data.body.enterpriseName
                            this.dataForm.venderCode = data.body.venderCode
                            this.dataForm.enterpriseNature = data.body.enterpriseNature
                            this.dataForm.venturePartner = data.body.venturePartner
                            this.dataForm.address = data.body.address
                            this.dataForm.creditCode = data.body.creditCode
                            this.dataForm.postCode = data.body.postCode
                            this.dataForm.legalPerson = data.body.legalPerson
                            this.dataForm.venderType = data.body.venderType
                            this.dataForm.taxNum = data.body.taxNum
                            this.dataForm.bankName = data.body.bankName
                            this.dataForm.fax = data.body.fax
                            this.dataForm.accountName = data.body.accountName
                            this.dataForm.accountNum = data.body.accountNum
                            this.dataForm.bankAddress = data.body.bankAddress
                            this.dataForm.paynum = data.body.paynum
                            this.dataForm.venderIntroduce = data.body.venderIntroduce
                            this.dataForm.swiftCode = data.body.swiftCode
                            this.dataForm.province = data.body.province
                            this.dataForm.city = data.body.city
                            this.dataForm.tel = data.body.tel
                            this.dataForm.website = data.body.website
                            this.dataForm.venderAbbreviation = data.body.venderAbbreviation
                            this.dataForm.venderExpierence = data.body.venderExpierence
                            this.dataForm.scEndDate = data.body.scEndDate
                            this.dataForm.blEndDate = data.body.blEndDate
                            this.dataForm.blLongTerm = data.body.blLongTerm
                            this.blLongTermChecked = data.body.blLongTerm === 1
                            // 回显：勾选长期时到期日期非必填
                            this.dataRule.blEndDate = this.blLongTermChecked ? [] : [{required: true, message: '不能为空', trigger: 'blur'}]
                        }
                    }
                    this.dataListLoading = false
                    this.setId()
                })
            },
            //保存数据到basicinfo表
            dataFormSubmit() {
                // 营执照长期标识：勾选长期时blEndDate不必填
                if (this.blLongTermChecked) {
                    this.dataForm.blLongTerm = 1
                    this.dataForm.blEndDate = ''
                } else {
                    this.dataForm.blLongTerm = 0
                    if (!this.dataForm.blEndDate) {
                        this.$message.error("营业执照到期日期不能为空");
                        return;
                    }
                }
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        // 保存basicinfo表
                        this.handleSaveLoading = true
                        saveSupplierBasicInfo({
                            'id': this.dataForm.basicInfoId || undefined,
                            'enterpriseNature': this.dataForm.enterpriseNature,
                            'venturePartner': this.dataForm.venturePartner,
                            'address': this.dataForm.address,
                            'creditCode': this.dataForm.creditCode,
                            'postCode': this.dataForm.postCode,
                            'legalPerson': this.dataForm.legalPerson,
                            'taxNum': this.dataForm.taxNum,
                            'bankName': this.dataForm.bankName,
                            'fax': this.dataForm.fax,
                            'accountName': this.dataForm.accountName,
                            'accountNum': this.dataForm.accountNum,
                            'bankAddress': this.dataForm.bankAddress,
                            'paynum': this.dataForm.paynum,
                            'venderIntroduce': this.dataForm.venderIntroduce,
                            'venderInviteFid': this.venderInviteFid,
                            'enterpriseName': this.dataForm.enterpriseName,
                            'venderCode': this.dataForm.venderCode,
                            'swiftCode': this.dataForm.swiftCode,
                            'venderType': this.dataForm.venderType,
                            'province': this.dataForm.province,
                            'city': this.dataForm.city,
                            'website': this.dataForm.website,
                            'tel': this.dataForm.tel,
                            'venderAbbreviation': this.dataForm.venderAbbreviation,
                            'venderExpierence': this.dataForm.venderExpierence,
                            'blEndDate': this.dataForm.blEndDate,
                            'blLongTerm': this.dataForm.blLongTerm,
                            'scEndDate': this.dataForm.scEndDate
                        }).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                })
                                this.showUsers = false
                                this.dataForm.basicInfoId = data.body
                                this.setId()
                                this.handleSaveLoading = false
                            } else {
                                this.handleSaveLoading = false
                                this.$message.error(data.msg)
                            }
                        }).catch((e) => {
                            this.handleSaveLoading = false
                        })
                    }
                })
            },
            // 省
            getProvinceList(){
                getProvinceList({
                    code: "",
                    name: "",
                }).then(data => {
                    if (data && data.code === '00') {
                        this.provinceOptions = data.body;
                    }
                });
            },
            // 银行
            getBankList() {
                getBankList({
                    bankCode: "",
                    bankName: "",
                }).then(data => {
                    if (data && data.code === '00') {
                        this.bankList = data.body;
                    }
                });
            },
            // 银行名称
            getBankName(val) {
                const bank = this.bankList.find(bank => bank.bankCode === val)
                return bank ? bank.bankName : ''
            },
            // 开户行行号——焦点离开事件
            blurSwiftCode: function (swiftCode) {
                setTimeout(() => {
                    if (null != swiftCode) {
                        const loading = this.$loading({
                            lock: true,
                            text: "开户行行号校验中,请稍候",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.7)",
                        });
                        getBankCount(
                            {
                                bankCode: swiftCode
                            }
                        ).then((data) => {
                            if (data && data.code === '00') {
                                if (data.body <= 0) {
                                    this.$message.error("开户行行号不合法");
                                    this.checkBankCode = false;
                                    loading.close();
                                } else {
                                    this.checkBankCode = true;
                                    loading.close();
                                }
                            } else {
                                this.$message.error(data.msg)
                                this.checkBankCode = false;
                                loading.close();
                            }
                        }).catch(function () {
                            loading.close();
                        });
                    }
                }, 300);
            },
            // 选择银行
            selectBank() {
                const _this = this;
                this.$refs.addOrUpdateBank.open();
                this.$refs.addOrUpdateBank.onClosed = (payload) => {
                    if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                        mapping(payload.data, _this.dataForm, ["id"]);
                        _this.dataForm.swiftCode = payload.data.bankCode;
                        _this.dataForm.bankName = payload.data.bankName;
                    }
                };
            },
            setId() {
                this.$emit('getId', this.dataForm.basicInfoId, this.venderInviteFid, this.dataForm.basicInfoId, this.createdBy, this.dataForm.workflowId)
            }
        }
    }
</script>
